<template>
  <div class="container container--padding">

    <div class="row logo logo--padding">
      <div class="col-12 col-md-7 offset-0 offset-md-1">
        <img class="logo_img" src="/dist/assets/front_white/img/vacancy/vacancy.svg" alt="Работа мечты в BIMLIB" />
      </div>
    </div>

    <div class="row mb-12 title-color">
      <div class="col-12 col-md-6 offset-0 offset-md-2">
        <div class="d-flex align-center mb-10 mb-md-11">
          <h1 class="title title--gradient d-inline-block mr-3 fz30 fz-md-48">Работа в BIMLIB</h1>
          <span class="title-unicorn"><img src="/dist/assets/front_white/img/vacancy/work@2x.png" alt=""></span>
        </div>
        <!-- <h4
          class="subtitle1 mb-10"
        >Строительная отрасль всегда двигала экономику вперед и при этом оставалась довольно консервативной по ряду причин Однако прогресс неостановим</h4> -->
        <p class="paragraph paragraph-color mb-10">
            Строительная отрасль всегда двигала экономику вперед и при этом оставалась довольно консервативной по ряду причин Однако прогресс неостановим и исходя из реальных потребностей современного рынка, стройка стремительно переходит «в цифру». Это уже случилось с финансовой отраслью и банками за последние несколько лет.
        </p>
        <p class="paragraph paragraph-color mb-10">
          Мы создали BIMLIB – библиотеку информационных моделей. Это как Shutterstock, только вместо фотографий – модели, а потребители контента – проектировщики и инженеры. На текущий момент BIMLIB является одной из самых крупных библиотек цифровых двойников в СНГ. Но на этом мы решили не останавливаться. Проектировщикам, инженерам и заказчикам проекта важно «в моменте» знать сколько стоит их проект, чтобы контролировать бюджеты. В 2019 году мы вывели на рынок новый продукт, который позволяет получать информацию о ценах и наличии строительной продукции и оборудования прямо в САПР за считанные секунды. До нас такого никто не делал и это считалось невозможным. «Под капотом» нейронная сеть и множество уникальных алгоритмов. Как результат – оперативная и актуальная оценка стоимости проекта, сформированная автоматически проектная документация и снижение затрат на реализацию проекта и эксплуатацию в будущем.
        </p>
        <p class="paragraph paragraph-color fw-bold mb-10">
          Наши новые продукты требуют вовлечения большего количества специалистов, в связи с чем мы расширяем штат и ищем таланты в нашу дружную команду профессионалов, которые стремятся менять мир. И да, мы планируем вырастить единорога, если вы понимаете о чем мы.
        </p>
      </div>
    </div>

    <div class="row listVacancies mb-12 title-color">
      <div class="col-12 col-md-6 offset-0 offset-md-2">
        <h3 class="listVacancies_title title fz28 pb-6 mb-9">Открытые вакансии</h3>
        <div class="listVacancies_script"></div>
        
        <!-- <p @click="vacancy = 'marketolog'" class="listVacancies_item listVacancies_item--margin"
        :class="{'active-color': vacancy === 'marketolog', 'listVacancies_item--active': vacancy === 'marketolog' }">Маркетолог</p>
        <div v-if="vacancy === 'marketolog'" class="row vacancy mb-11 title-color">
          <div class="col-12">

            <div class="vacancy_terms d-flex flex-nowrap mb-9">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph fw-bold">3-6 лет</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph fw-bold">5/2, полный день</p>
              </div>
            </div>

            <div class="functions mb-10">
              <h5 class="paragraph fw-bold mb-6">Обязанности:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">планирование маркетинговой политики, построение стратегии;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">продвижение бренда на рынке;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">постоянный мониторинг и анализ рынка, конкурентов, медиа;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">ведение и контроль рекламных компаний;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">работа с социальными медиа (SMM);</li>
                <li class="vacancy_list-item vacancy_list-item--margin">разработка и заказ рекламно-информационных материалов;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">взаимодействие с командой операционного управления и технической 	командой;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">взаимодействие с агентствами, подрядчиками, ведение необходимого 	документооборота;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">оценка эффективности маркетинговых мероприятий, их вклада в динамику 	роста аудитории продукта;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">постоянный поиск новых возможностей для продвижения продукта.</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Требования:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">опыт продвижения крупных интернет-проектов, инновационных продуктов, 	online-медиа, веб-сервисов на международном рынке;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">навыки управления проектами;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">экспертное знание сервисов аналитики;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">нестандартное мышление, желание учиться, развиваться и работать в команде;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">ответственность и умение работать в режиме многозадачности;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">знание английского языка не ниже уровня Intermediate.</li>
              </ul>
            </div>

            <div class="mb-9">
              <h5 class="paragraph fw-bold mb-6">От нас:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">комфортный офис;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">отсутствие бюрократии;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">интересные задачи;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">чай, печенье.</li>
              </ul>
            </div>

            <p class="paragraph fw-bold fz14 mb-9">
              Мы не ищем людей, которые умеют только SMM или настройку Яндекс.Директ. В нашем понимании, хороший маркетолог это «мультиинструменталист», поэтому помимо знаний в сфере экономики и финансов, маркетологу должно быть присуще хорошо развитое логическое мышление, аналитический склад ума, умение сосредоточиться, знание психологии и социологии, отличные коммуникативные навыки.
            </p>

            <p class="paragraph fw-bold fz14">
              Не рассматриваются резюме БЕЗ сопроводительного письма. В сопроводительном письме просим кратко рассказать о ваших самых успешный кейсах, роли участия и вовлеченности.
            </p>

            <div v-if="vacancy !== ''" class="row vacancy_button mt-10">
              <div class="offset-0 col-2">
                <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
              </div>
            </div>
          </div>
        </div> -->
        <p id="javaDev" @click="accordeon('javaDev')" class="listVacancies_item listVacancies_item--margin"
        :class="{'active-color': vacancy === 'javaDev', 'listVacancies_item--active': vacancy === 'javaDev' }"
        >Программист Java (Middle Java Developer)</p>
        <div v-show="vacancy === 'javaDev'" class="row vacancy mb-11 title-color">
          <div class="col-12">
            <!-- <h2 class="title2 mb-9">Программист Java (Middle Java Developer)</h2> -->

            <div class="vacancy_terms d-flex flex-nowrap mb-9">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph fw-bold">1–3 года</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph fw-bold">5/2 полный день</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Оплата</span>
                <p class="paragraph fw-bold">от 140 000 руб. на руки</p>
              </div>
            </div>

            <div class="functions mb-10">
              <h5 class="paragraph fw-bold mb-6">Обязанности:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Разработка программных компонентов платформы BIMLIB</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Участие в проектировании платформы</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Review существующего кода и рефакторинг</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Тестирование и документация разрабатываемых решений</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Мы ожидаем от соискателя:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Способность выполнять порученную работу (желательно продемонстрировать портфолио выполненных проектов). Готовность решать сложные задачи.</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Умение критически оценивать технологии разработки программного обеспечения.</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Представление о современных средствах командной разработки и DevOps</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Понимание парадигм программирования (императивное, функциональное, ...)</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Представление о компонентах многоуровневых корпоративных приложений и интерфейсах их взаимодействия</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Общее представление и знание основных паттернов проектирования</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Понимание важности модульного и пр. видов тестирования</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Мы используем:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Java 8+, Spring Framework, JPA/Hibernate ORM, JAX-RS/RESTEasy</li>
                <li class="vacancy_list-item vacancy_list-item--margin">PostgreSQL, Amazon S3/MinIO, Redis</li>
                <li class="vacancy_list-item vacancy_list-item--margin">RabbitMQ</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Git/GitLab</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Docker, Kubernetes</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Vue.js/Quasar Framework</li>
              </ul>
            </div>

            <div>
              <h5 class="paragraph fw-bold mb-6">От нас:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Комфортный офис</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Отсутствие бюрократии</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Интересные задачи</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Чай, печенье</li>
              </ul>
            </div>
            <div v-if="vacancy !== ''" class="row vacancy_button mt-10">
              <div class="offset-0 col-2">
                <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
              </div>
            </div>
          </div>
        </div>

        <p id="bk" @click="accordeon('bk')" class="listVacancies_item listVacancies_item--margin"
        :class="{'active-color': vacancy === 'bk', 'listVacancies_item--active': vacancy === 'bk' }"
        >Специалист ОВиК / ВК (BIM)</p>
        <div v-show="vacancy === 'bk'" class="row vacancy mb-11 title-color">
          <div class="col-12">

            <div class="vacancy_terms d-flex flex-nowrap mb-9">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph fw-bold">1–3 года</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph fw-bold">5/2 полный день</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Оплата</span>
                <p class="paragraph fw-bold">от 50 000 до 70 000 руб. на руки</p>
              </div>
            </div>

            <div class="functions mb-10">
              <h5 class="paragraph fw-bold mb-6">Обязанности:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Разработка компонентов информационной модели (семейств) элементов отопления, вентиляции, кондиционирования, водоснабжения, канализации</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Разработка технических заданий на создание моделей (семейств)</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Общение с заказчиком по локальным задачам</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Соблюдение внутренних регламентов</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Мы ожидаем от соискателя:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Свободное владение ПК, Autodesk Revit, AutoCAD, MS Office (Word, Excel)</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Опыт проектирования разделов ОВиК/ВК в Autodesk Revit не менее 1 года</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Опыт в разработке семейств</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Умение работать в Dynamo приветствуется</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Умение грамотно излагать свои мысли как в живом общении так и «на бумаге»</li>
              </ul>
            </div>

            <div class="mb-9">
              <h5 class="paragraph fw-bold mb-6">От нас:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Комфортный офис</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Отсутствие бюрократии</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Интересные задачи</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Чай, печенье</li>
              </ul>
            </div>

            <div v-if="vacancy !== ''" class="row vacancy_button mt-10">
              <div class="offset-0 col-2">
                <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
              </div>
            </div>
          </div>
        </div>

        <p id="analyst" @click="accordeon('analyst')" class="listVacancies_item listVacancies_item--margin"
        :class="{'active-color': vacancy === 'analyst', 'listVacancies_item--active': vacancy === 'analyst' }"
        >Аналитик/технический писатель</p>
        <div v-show="vacancy === 'analyst'" class="row vacancy mb-11 title-color">
          <div class="col-12">

            <div class="vacancy_terms d-flex flex-nowrap mb-9">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph fw-bold">1–3 года</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph fw-bold">5/2 полный день</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Оплата</span>
                <p class="paragraph fw-bold">от 70 000 руб. на руки</p>
              </div>
            </div>

            <div class="functions mb-10">
              <h5 class="paragraph fw-bold mb-6">Обязанности:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Разработка и согласование функциональных и не функциональных требований к разрабатываемому программному обеспечению</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Описание сценариев и алгоритмов работы программного обеспечения, форматов и протоколов информационного обмена между модулями, а также с внешними системами</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Взаимодействие с командой проекта для сбора технической информации по проекту</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Разработка и поддержание в актуальном состоянии технической, программной и эксплуатационной документации</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Участие в разработке и внедрении шаблонов документов различного назначения</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Мы ожидаем от соискателя:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Знание английского языка на уровне чтения технической документации</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Умение правильно формулировать и корректно излагать свои мысли</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Опыт в формализации требований и написании технических заданий для разработчиков</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Знание языков моделирования систем и методологий UML, SysML, IDEF</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Ответственность и внимание к деталям</li>
              </ul>
            </div>

            <div class="mb-9">
              <h5 class="paragraph fw-bold mb-6">От нас:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Комфортный офис в шаговой доступности от метро</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Отсутствие бюрократии</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Интересные задачи</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Чай, печенье</li>
              </ul>
            </div>

            <div v-if="vacancy !== ''" class="row vacancy_button mt-10">
              <div class="offset-0 col-2">
                <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
              </div>
            </div>
          </div>
        </div>

        <p id="sales" @click="accordeon('sales')" class="listVacancies_item listVacancies_item--margin"
        :class="{'active-color': vacancy === 'sales', 'listVacancies_item--active': vacancy === 'sales' }"
        >Менеджер по продажам услуг</p>
        <div v-show="vacancy === 'sales'" class="row vacancy mb-11 title-color">
          <div class="col-12">

            <div class="vacancy_terms d-flex flex-nowrap mb-9">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph fw-bold">1–3 года</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph fw-bold">5/2 полный день</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Оплата</span>
                <p class="paragraph fw-bold">от 70 000 руб. на руки</p>
              </div>
            </div>

            <div class="functions mb-10">
              <h5 class="paragraph fw-bold mb-6">Обязанности:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Работа с потенциальными клиентами (поиск и привлечение)</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Подготовка коммерческих предложений</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Проведение переговоров и презентаций продукта по телефону и на встречах с клиентами</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Участие в выставках, семинарах и конференциях с целью повышения заинтересованности клиентской аудитории в продуктах и услугах Компании</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Ведение клиентской базы (amoCRM)</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Мы ожидаем от соискателя:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Опыт личных или телефонных продаж</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Опыт работы с первыми лицами компаний, проведения презентаций приветствуется</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Опыт холодных звонков</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Знание техник продаж и умение применять их на практике</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Личностные качества: коммуникабельность, желание расти и развиваться в продажах, умение убеждать, ориентация на результат, ответственность, стрессоустойчивость, активность</li>
              </ul>
            </div>

            <div class="mb-9">
              <h5 class="paragraph fw-bold mb-6">От нас:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">Комфортный офис в шаговой доступности от метро</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Отсутствие бюрократии</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Интересные задачи</li>
                <li class="vacancy_list-item vacancy_list-item--margin">Чай, печенье</li>
              </ul>
            </div>

            <div v-if="vacancy !== ''" class="row vacancy_button mt-10">
              <div class="offset-0 col-2">
                <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- <p @click="vacancy = 'frontEnd'" class="listVacancies_item listVacancies_item--margin"
        :class="{'active-color': vacancy === 'frontEnd', 'listVacancies_item--active': vacancy === 'frontEnd' }"
        >Frontend разработчик (HTML5, CSS3, Vue.js)</p>
        <div v-if="vacancy === 'frontEnd'" class="row vacancy mb-11 title-color">
          <div class="col-12">

            <div class="vacancy_terms d-flex flex-nowrap mb-9">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph fw-bold">1–3 года</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph fw-bold">5/2, полный день</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph op05 fz14 fw-bold">Оплата</span>
                <p class="paragraph fw-bold">от 75 000 руб. на руки</p>
              </div>
            </div>

            <div class="functions mb-10">
              <h5 class="paragraph fw-bold mb-6">Требования:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">хорошие знания JavaScript (ES5+);</li>
                <li class="vacancy_list-item vacancy_list-item--margin">знание HTML5, CSS3, опыт кроссбраузерной и адаптивной верстки (Flexbox);</li>
                <li class="vacancy_list-item vacancy_list-item--margin">опыт использования CSS препроцессоров (SASS, SCSS, Stylus);</li>
                <li class="vacancy_list-item vacancy_list-item--margin">опыт работы с фреймворком Vue.js;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">опыт взаимодействия с веб-сервисами (REST API);</li>
                <li class="vacancy_list-item vacancy_list-item--margin">опыт работы с Git или с любой другой системой контроля версий;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">умение отлаживать код;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">умение писать чистый, валидный код;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">умение документировать код;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">умение работать в команде.</li>
              </ul>
            </div>

            <div class="mb-10">
              <h5 class="paragraph fw-bold mb-6">Плюсом будет:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">опыт использования одной из систем сборки (Gulp, Grunt, Webpack);</li>
                <li class="vacancy_list-item vacancy_list-item--margin">опыт работы с фреймворками React и Angular;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">опыт работы с Regexp;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">владение Photoshop, Zeplin, Wrike.</li>
              </ul>
            </div>

            <div class="mb-9">
              <h5 class="paragraph fw-bold mb-6">От нас:</h5>
              <ul class="vacancy_list">
                <li class="vacancy_list-item vacancy_list-item--margin">комфортный офис;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">отсутствие бюрократии;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">интересные задачи;</li>
                <li class="vacancy_list-item vacancy_list-item--margin">чай, печенье.</li>
              </ul>
            </div>

            <p class="paragraph fw-bold fz14 mb-3">
              ВАЖНО!
            </p>

            <p class="paragraph fw-bold fz14">
              Уважаемые кандидаты, пожалуйста прикрепляйте к резюме ссылки на 2-3 проекта, которые сверстаны именно вами. Резюме без портфолио не рассматриваются. Кандидатов для удалённого сотрудничества не рассматриваем.
            </p>

            <div v-if="vacancy !== ''" class="row vacancy_button mt-10">
              <div class="offset-0 col-2">
                <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- <div v-if="vacancy !== ''" class="row">
      <div class="offset-2 col-2">
        <v-btn @click="openModal = 'open'" color="green" big class="fz18">Откликнуться</v-btn>
      </div>
    </div> -->

    <modalRequestVacancy v-if="openModal === 'open'" @close="openModal = 'close'" :vacancy_select="vacancy"></modalRequestVacancy>

  </div>
</template>

<script>
import modalRequestVacancy from "./ModalRequestVacancy";
export default {
  components: {
    modalRequestVacancy,
  },
  data() {
    return {
      vacancy: '',
      openModal: 'close',
    }
  },
  mounted() { 
    let hhScript = document.createElement('script');
    hhScript.setAttribute('src', 'https://api.hh.ru/widgets/vacancies/employer?employer_id=3101894&locale=RU&links_color=02a497&border_color=02a497&show_region=true');
    hhScript.setAttribute('class', 'hh-script');
    document.querySelector('.listVacancies_script').appendChild(hhScript);
  },
  methods: {
    accordeon(vacancyName) {
      if (this.vacancy !== vacancyName) {
        this.vacancy = vacancyName
        // this.$nextTick(() => {
        //   const el = document.getElementById(vacancyName)
        //   el.scrollIntoView({block: "center", behavior: "smooth"})
        // })
      } else this.vacancy = ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.listVacancies_script {
  margin-bottom: 24px;
}

.container--padding {
  padding-top: 80px;
  padding-bottom: 158px;
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
		padding-top: 32px;
	}
}
.logo--padding {
  padding-bottom: 80px;
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
		padding-bottom: 40px;
	}
}
.logo_img {
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
		max-width: 100%;
	}
}
.title--gradient {
  background: linear-gradient(85deg, #ff8989, #ff9479 30%, #ffd153 70%, #ff7d62);;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.title-unicorn {
  width: 46px;
  height: 48px;
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
		@include size(32px);
	}
  img {
    width: 100%;
    height: 100%;
  }
}
.listVacancies {
  &_title {
    // border-bottom: solid 1px #c1c1c1;
  }
  &_item {
    @include font-main(24px, bold, 1.35, normal, $text-some-titles);
    cursor: pointer;
    border-bottom: solid 1px #c1c1c1;
    padding-bottom: 12px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      right: 5px;
      top: 50%;
      // transform: translateY(40%);
      transform: translateY(-50%) rotate(225deg);
      width: 10px;
      height: 10px;
      border-top: 1px solid #c1c1c1;
      border-left: 1px solid #c1c1c1;
  }
    &:hover {
      opacity: 0.75;
    }
    &--margin {
      &:not(:last-child) {
        margin-bottom: 14px;
      }
    }
  }
  &_item--active {
    &:after {
      transform: translateY(-20%) rotate(45deg);
    }
  }
}

.vacancy {
  &_terms-block {
    &--margin:not(:last-child) {
      margin-right: 32px;
    }
  }
  &_list {
    position: relative;
    padding-left: 26px;
    &-item {
      @include font-main(17px, normal, 1.41, normal, inherit);
      &:before {
        content: '-';
        position: absolute;
        left: 0;
      }
      &--margin:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
  &_button {
    -webkit-text-fill-color: #fff;
  }
}
</style>
